import React, { useEffect, useState } from 'react';
import './ConvictionRing.css';
import { convictionColor } from '../utils/convictionLabel';

// Reusable conviction ring gauge (the grade-view headline). Draws in on mount;
// color follows the five conviction labels (utils/convictionLabel.js). Used by the
// restyled Screener + Portfolio expanded views so they match the grade view.
const R = 46;
const CIRC = 2 * Math.PI * R;

export default function ConvictionRing({ score, size = 110 }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(false);
    const id = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(id);
  }, [score]);

  const s = Math.max(0, Math.min(100, Math.round(score || 0)));
  const color = convictionColor(s);
  const off = mounted ? CIRC * (1 - s / 100) : CIRC;

  return (
    <div className="cvring" style={{ width: size, height: size }}>
      <svg viewBox="0 0 108 108" width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx="54" cy="54" r={R} fill="none" stroke="#0E1626" strokeWidth="11" />
        <circle
          cx="54" cy="54" r={R} fill="none"
          stroke={color} strokeWidth="11" strokeLinecap="round"
          strokeDasharray={CIRC} strokeDashoffset={off}
          style={{ transition: 'stroke-dashoffset 1s cubic-bezier(0.22, 1, 0.36, 1)' }}
        />
      </svg>
      {/* 2026-09-11: the inner type was fixed at 34px/10px in CSS regardless of
          `size`, so any ring smaller than the 110px default had the number
          overflow its own circle. Scale it from the size instead. */}
      <div className="cvring-c">
        <div className="cvring-n" style={{ color, fontSize: Math.round(size * 0.31) }}>{s}</div>
        <div className="cvring-d" style={{ fontSize: Math.max(8, Math.round(size * 0.091)) }}>/ 100</div>
      </div>
    </div>
  );
}
